import { atom, selector } from 'recoil';

interface inputCaptcha {
  input: String;
  error: Boolean;
}

export const captchaState = atom({
  key: 'captchaState',
  default: '',
});

export const inputCaptchaState = atom({
  key: 'inputCaptchaState',
  default: {} as inputCaptcha,
});

export const captchaInfo = selector({
  key: 'captchaInfo',
  get: ({ get }) => ({
    value: get(captchaState),
    input: get(inputCaptchaState).input,
    error: get(inputCaptchaState).error,
  }),
});
